import { z } from 'zod';

import {
  DimensionFormatTypeSchema,
  MetricFormatSchema,
  MetricScaleSchema,
} from './common.js';

export const FilterConditionSchema = z.enum([
  'is',
  'isn’t',
  'contains',
  'less',
  'greater',
  'equal',
  'not_equal',
  'between',
  'min',
  'max',
]);

const FilterInternalSchema = z.object({
  isPermanent: z.boolean().optional(),
  key: z.string().optional(),
});

export const TimeFilterSchema = FilterInternalSchema.extend({
  id: z.string(),
  name: z.string(),
  startDate: z.string().nullable().optional(),
  endDate: z.string().nullable().optional(),
  periodId: z.string().optional(),
  comparisonDateFrom: z.string().nullable().optional(),
  comparisonDateTo: z.string().nullable().optional(),
  dataBucketing: MetricScaleSchema.nullable().optional(),
  isAggregationAvailable: z.boolean().optional(),
  isAggregationOn: z.boolean().optional(),
  isTotalAggregationEnabled: z.boolean().optional(),
  dimensionType: DimensionFormatTypeSchema.optional(),
});

export const DimensionsFilterSchema = FilterInternalSchema.extend({
  id: z.string(),
  name: z.string(),
  condition: FilterConditionSchema,
  options: z.array(z.string()),
  dimensionType: DimensionFormatTypeSchema.optional(),
  dataBucketing: MetricScaleSchema.nullable().optional(),
  valueType: DimensionFormatTypeSchema.optional(),
});

export const MetricFilterSchema = FilterInternalSchema.extend({
  id: z.string(),
  name: z.string(),
  condition: FilterConditionSchema,
  options: z.array(z.string()),
  metricType: MetricFormatSchema,
  dataBucketing: MetricScaleSchema.nullable().optional(),
  activeWidgetId: z.string().optional(),
  currencyId: z.string().optional(),
});

export const FilterSchema = z.union([
  MetricFilterSchema,
  DimensionsFilterSchema,
  TimeFilterSchema,
]);
